import { authFetch } from "./api";
import { TAILWIND_COLOR_HEX } from "./tailwindColors";

const API_BASE_URL = "/api3009";

/** 未読状態の再取得トリガー（詳細既読後など） */
export const SUPPLIER_ANNOUNCEMENT_UNREAD_CHANGED = "supplier-announcement-unread-changed";

export function getAuthHeader() {
    return { "Content-Type": "application/json" };
}

/** 公開日時を YYYY/MM/DD 形式で表示 */
export function formatPublishedDate(value) {
    if (!value) return "—";
    const dt = new Date(value);
    if (isNaN(dt.getTime())) return "—";
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const d = String(dt.getDate()).padStart(2, "0");
    return `${y}/${m}/${d}`;
}

export const DEFAULT_CATEGORY_COLOR = "text-gray-500";

const TAILWIND_COLOR_NAMES = [
    "slate", "gray", "zinc", "red", "orange", "amber", "yellow", "lime", "green", "emerald",
    "teal", "cyan", "sky", "blue", "indigo", "violet", "purple", "fuchsia", "pink", "rose",
];

/** カテゴリ色を text-{name}-500 形式に正規化 */
export function normalizeCategoryColor(value) {
    if (typeof value !== "string") {
        return DEFAULT_CATEGORY_COLOR;
    }
    const trimmed = value.trim();
    const match = trimmed.match(/^text-([a-z]+)-500$/);
    if (!match || !TAILWIND_COLOR_NAMES.includes(match[1])) {
        return DEFAULT_CATEGORY_COLOR;
    }
    return trimmed;
}

/** カテゴリタグ表示用スタイル */
export function getCategoryStyle(color) {
    const normalized = normalizeCategoryColor(color);
    const token = normalized.replace(/^text-/, "");
    const hex = TAILWIND_COLOR_HEX[token] || TAILWIND_COLOR_HEX["gray-500"];
    return {
        dotStyle: { backgroundColor: hex },
        textStyle: { color: hex },
    };
}

export async function fetchAnnouncementCategories() {
    const res = await authFetch(`${API_BASE_URL}/get_m_announcement_category_list`);
    if (!res.ok) throw new Error("Failed to fetch categories");
    const json = await res.json();
    return json.data ?? [];
}

export async function fetchHasUnread() {
    const res = await authFetch(`${API_BASE_URL}/get_announcement_has_unread`);
    if (!res.ok) throw new Error("Failed to fetch unread status");
    const json = await res.json();
    return Boolean(json.data?.has_unread);
}

export async function fetchRecentAnnouncements() {
    const res = await authFetch(`${API_BASE_URL}/get_announcement_recent`);
    if (!res.ok) throw new Error("Failed to fetch recent announcements");
    return res.json();
}

export function isMobileViewport() {
    return typeof window !== "undefined" && window.innerWidth < 768;
}

export function isPreviewableFileName(fileName) {
    const ext = String(fileName || "").split(".").pop()?.toLowerCase() || "";
    return ["pdf", "png", "jpg", "jpeg", "webp", "gif"].includes(ext);
}

export async function fetchAnnouncementAttachment(announcementId, fileId) {
    const res = await authFetch(
        `${API_BASE_URL}/get_announcement_attachment_s3?announcement_id=${announcementId}&announcement_file_id=${fileId}`
    );
    if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error(json.error || "Failed to load attachment");
    }
    const json = await res.json();
    return json.data;
}

export function base64ToBlobUrl(base64, contentType) {
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const blob = new Blob([bytes], { type: contentType });
    return URL.createObjectURL(blob);
}

export function notifyAnnouncementUnreadChanged() {
    window.dispatchEvent(new CustomEvent(SUPPLIER_ANNOUNCEMENT_UNREAD_CHANGED));
}

export { API_BASE_URL };
